import ArticleEditor from './editors/ArticleEditor';

function EntityEditor() {
  return <ArticleEditor />;
}

export default EntityEditor;
